module.exports = __webpack_public_path__ + "img/people-shopping-with-bags.c98dbefb.png";